module.exports = {
    "Empty": `\u{41F}\u{443}\u{441}\u{442}\u{43E}`
};


//# sourceMappingURL=uk-UA.main.js.map
